import {entityIndicadoresFeatureKey, selectAll, selectEntities} from './entity-indicador.reducer';
import {selectors} from '~utils/ngrx-util';

const {
  entitySelectAll,
  entitySelectEntities,
  entitySelectById,
} = selectors(entityIndicadoresFeatureKey, {selectAll, selectEntities});

export const entityIndicadoresSelectAll = entitySelectAll;
export const entityIndicadorSelectEntities = entitySelectEntities;
export const entityIndicadorSelectById = entitySelectById;
